<template>
  <md-card class="activity-card clickables">
    <pagination-trigger
        v-if="enableTrigger"
        @triggerIntersected="paginateAllFriends"
    />
    <div
      class="clickable"
      @click="redirectToActivity(activity.activityId)"
    >
      <md-card-header>
        <md-avatar>
          <img
            :src="activity.userImage || defaultImage"
            alt="Avatar"
          >
        </md-avatar>

        <div v-if="activity.badges">
          <md-avatar
            v-for="badge in activity.badges"
            :key="badge.name"
          >
            <img
              :src="badge.icon"
              :title="badge.name"
            >
          </md-avatar>
        </div>

        <div class="md-title">
          <i :class="[{ [formatActitivityIcon(activity.activityType)]: true }]" />
          {{ activity.title }}
          <i v-if="activity.externalDataSourceId">
          <small>({{ getSource(activity.externalDataSourceId) }})</small>
          </i>
        </div>
        <p
          class="date"
          style="text-align: left;"
        >
          {{ formatDate(activity.start, true) }}
        </p>
      </md-card-header>

      <md-card-media
        v-if="activity.titleImage"
        class="md-ratio-4-3 md-card-plain md-card-header-image" style="margin: 0"
      >
        <img
          :src="activity.titleImage"
        >
      </md-card-media>
      <md-card-content>
        <div>
          <ul class="activityData">
            <li v-if="activity.data.distanceInMeters">
              <div class="name">
                <i class="far fa-ruler-horizontal" /> Distanz
              </div>
              <b class="value">{{
                formatM2Km(activity.data.distanceInMeters)
              }}</b>
            </li>
            <li v-if="activity.durationInSeconds">
              <div class="name">
                <i class="far fa-stopwatch" /> Dauer
              </div>
              <b class="value">{{
                formatS2M(activity.durationInSeconds)
              }}</b>
            </li>
            <li
              v-if="activity.data.averageSpeedInMetersPerSecond && activity.activityType == 3"
            >
              <div class="name">
                <i class="fal fa-tachometer-fast" /> Tempo
              </div>
              <b class="value">{{
                formatSpeed(activity.data.averageSpeedInMetersPerSecond)
              }}</b>
            </li>
            <li
              v-if="activity.data.averageSpeedInMetersPerSecond && activity.activityType != 3"
            >
              <div class="name">
                <i class="fal fa-tachometer-fast" /> Pace
              </div>
              <b class="value">{{
                formatPace(
                  formatSpeed2Pace(
                    activity.data.averageSpeedInMetersPerSecond
                  )
                )
              }}</b>
            </li>

            <li v-if="activity.data.calories">
              <div class="name">
                <i class="fal fa-fire" /> kcal
              </div>
              <b class="value">{{ activity.data.calories }}</b>
            </li>

            <li
              v-if="activity.data.averagePaceInMinutesPerKilometer"
            >
              <div class="name">
                <i class="fal fa-tachometer-fast" /> Pace
              </div>
              <b class="value">{{
                formatPace(activity.data.averagePaceInMinutesPerKilometer)
              }}</b>
            </li>

            <li v-if="activity.data.totalElevationGainInMeters">
              <div class="name">
                <i class="fal fa-ruler" /> Anstieg
              </div>
              <b class="value">
                {{ activity.data.totalElevationGainInMeters.toFixed(2) }}
              </b>
            </li>
          </ul>
        </div>
      </md-card-content>
    </div>

    <md-card-actions
      class="md-alignment-right"
    >
      <div
        v-if="activity.liked"
      >
        {{ activity.liked.length || 0 }}
        <i
          class="clickable"
          :class="[liked(activity) ? 'fas fa-heart' : 'fal fa-heart', (likeable(activity))?'active':'']"
          @click="like(activity)"
        />
      </div>
    </md-card-actions>
  </md-card>
</template>

<script>
import {mapState} from "vuex";
import datetime from "../../utils/datetime";
import activity from "../../utils/activity";
import PaginationTrigger from '../atoms/pagination-trigger';

export default {
  name: 'ActivityCard',
  components: {PaginationTrigger},
  props: {
    activity: {
      type: Object,
      required: true,
    },
    enableTrigger: {
      type: Boolean
    },
    stopIntersecting: {
      type: Boolean
    },
  },
  data() {
    return {
      defaultImage: this.$store.state.defaultAvatar,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  methods: {
    ...datetime,
    ...activity,
    likeable(item) {
      if (item.userId == this.user._id) return false;
      return true
    },
    liked(item) {
      if (item.liked.includes(this.user._id)) return true;
      return false
    },
    like(item) {
      if (!(item.activityId && this.likeable(item))) return false;
      this.$emit('like', item);
    },
    redirectToActivity(activityId) {
      this.$emit('redirectToActivity', activityId);
    },
    paginateAllFriends() {
      setTimeout(() => {
        if (!this.stopIntersecting) {
          this.$emit('paginateActivities');
        }
      })
    }
  }
}
</script>

<style lang="scss">
div.activity-card div.md-card-content {
  padding-top: 0;
}
ul.activityData {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
ul.activityData > li {
  margin-left: 0;
  margin-right: 12px;
  padding-right: 12px;
  position: relative;
  margin-bottom: 0.75em;
}
ul.activityData > li:after {
  content: "";
  display: block;
  border-right: 1px solid #f0f0f5;
  height: 24px;
  width: 1px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -12px;
}
</style>
